module.exports = __webpack_public_path__ + "static/media/icon-up.e89c8eef.svg";